import { useNavigate } from 'react-router-dom'

import { Button, Icon, Image, Text } from '@/ui'
import { TextColors, TypographyStyles } from '@/styles'
import { faTimer } from '@fortawesome/pro-regular-svg-icons'
const AnnualTaxTskEntryPoint = () => {
  const navigate = useNavigate()

  return (
    <div className="flex items-center justify-center pt-20">
      <div className="flex flex-col items-center justify-center max-w-[600px] gap-10">
        <Image
          src="https://heard-images.s3.amazonaws.com/assets/compass.svg"
          alt="compass"
          height={250}
          width={250}
        />
        <div className="flex flex-col items-center gap-4">
          <Text variant={TypographyStyles.DISPLAY_MD} textAlign="center">
            Start your path to a smooth tax season
          </Text>
          <Text
            variant={TypographyStyles.BODY_MD}
            textAlign="center"
            className="leading-[150%] w-[520px]"
          >
            Complete your <b>Tax Season Kickoff</b> to personalize your filing
            plan. This helps us create custom steps and deadlines to guide you
            smoothly through tax season.
          </Text>

          <Text
            variant={TypographyStyles.BODY_XS}
            color={TextColors.MUTED}
            textAlign="center"
            className="flex"
          >
            <Icon icon={faTimer} className="mr-1" color={TextColors.MUTED} />5
            minutes
          </Text>
        </div>

        <div className="justify-center flex">
          <Button onClick={() => navigate('/taxes/annual/kickoff-survey')}>
            Continue
          </Button>
        </div>
      </div>
    </div>
  )
}

export default AnnualTaxTskEntryPoint
